// Auto-generated from 'Yahah Required data.csv'. Source of truth for the
// Year/Make/Model/Part multi-level filter shown across the site.
let makeObject3 = {
  "Engine": {
    "Chevy": {
      "Blazer (2019 Up)": [
        2019,
        2020
      ],
      "Blazer, S10/S15": [
        1999,
        2000,
        2001,
        2002,
        2003,
        2004,
        2005
      ],
      "Camaro": [
        1999,
        2000,
        2001,
        2002,
        2010,
        2011,
        2012,
        2013,
        2014,
        2015,
        2016,
        2017,
        2018,
        2019,
        2020
      ],
      "Captiva Sport": [
        2012,
        2013,
        2014,
        2015
      ],
      "Cavalier": [
        1999,
        2000,
        2001,
        2002,
        2003,
        2004,
        2005
      ],
      "Cobalt": [
        2005,
        2006,
        2007,
        2008,
        2009,
        2010
      ],
      "Corvette": [
        1999,
        2000,
        2001,
        2002,
        2003,
        2004,
        2005,
        2006,
        2007,
        2008,
        2009,
        2010,
        2011,
        2012,
        2013,
        2014,
        2015,
        2016,
        2017,
        2018,
        2019
      ],
      "Cruze": [
        2011,
        2012,
        2013,
        2014,
        2015,
        2016,
        2017,
        2018,
        2019
      ],
      "Equinox": [
        2005,
        2006,
        2007,
        2008,
        2009,
        2010,
        2011,
        2012,
        2013,
        2014,
        2015,
        2016,
        2017,
        2018,
        2019,
        2020
      ],
      "Impala": [
        2000,
        2001,
        2002,
        2003,
        2004,
        2005,
        2006,
        2007,
        2008,
        2009,
        2010,
        2011,
        2012,
        2013,
        2014,
        2015,
        2016,
        2017,
        2018,
        2019,
        2020
      ],
      "Malibu": [
        1999,
        2000,
        2001,
        2002,
        2003,
        2004,
        2005,
        2006,
        2007,
        2008,
        2009,
        2010,
        2011,
        2012,
        2013,
        2014,
        2015,
        2016,
        2017,
        2018,
        2019,
        2020
      ],
      "Monte Carlo": [
        1999,
        2000,
        2001,
        2002,
        2003,
        2004,
        2005,
        2006,
        2007
      ],
      "S10/S15/Sonoma": [
        1999,
        2000,
        2001,
        2002,
        2003,
        2004
      ],
      "Suburban-1500": [
        1999,
        2000,
        2001,
        2002,
        2003,
        2004,
        2005,
        2006,
        2007,
        2008,
        2009,
        2010,
        2011,
        2012,
        2013,
        2014,
        2015,
        2016,
        2017,
        2018,
        2019,
        2020
      ],
      "Suburban-2500": [
        1999,
        2000,
        2001,
        2002,
        2003,
        2004,
        2005,
        2006,
        2007,
        2008,
        2009,
        2010,
        2011,
        2012,
        2013
      ],
      "Suburban-3500": [
        2016,
        2017,
        2018
      ],
      "Tahoe": [
        1999,
        2000,
        2001,
        2002,
        2003,
        2004,
        2005,
        2006,
        2007,
        2008,
        2009,
        2010,
        2011,
        2012,
        2013,
        2014,
        2015,
        2016,
        2017,
        2018,
        2019,
        2020
      ],
      "TrailBlazer": [
        2002,
        2003,
        2004,
        2005,
        2006,
        2007,
        2008,
        2009
      ],
      "Traverse": [
        2009,
        2010,
        2011,
        2012,
        2013,
        2014,
        2015,
        2016,
        2017,
        2018,
        2019,
        2020
      ],
      "Truck-1500 Series (1988-1999)": [
        1999
      ],
      "Truck-Avalanche 1500": [
        2002,
        2003,
        2004,
        2005,
        2006,
        2007,
        2008,
        2009,
        2010,
        2011,
        2012,
        2013
      ],
      "Truck-Colorado": [
        2004,
        2005,
        2006,
        2007,
        2008,
        2009,
        2010,
        2011,
        2012,
        2015,
        2016,
        2017,
        2018,
        2019,
        2020
      ],
      "Truck-Silverado 1500 (1999 Up)": [
        1999,
        2000,
        2001,
        2002,
        2003,
        2004,
        2005,
        2006,
        2007,
        2008,
        2009,
        2010,
        2011,
        2012,
        2013,
        2014,
        2015,
        2016,
        2017,
        2018,
        2019,
        2020
      ],
      "Truck-Silverado 2500 (1999 Up)": [
        2000,
        2001,
        2002,
        2003,
        2004,
        2005,
        2006,
        2007,
        2008,
        2009,
        2010,
        2011,
        2012,
        2013,
        2014,
        2015,
        2016,
        2017,
        2018,
        2019,
        2020
      ],
      "Truck-Silverado 3500 (2001 Up)": [
        2001,
        2002,
        2003,
        2004,
        2005,
        2006,
        2007,
        2008,
        2009,
        2010,
        2011,
        2012,
        2013,
        2014,
        2015,
        2016,
        2017,
        2018,
        2019,
        2020
      ],
      "Van Express 1500": [
        1999,
        2000,
        2001,
        2002,
        2003,
        2004,
        2005,
        2006,
        2007,
        2008,
        2009,
        2010,
        2011,
        2012,
        2013,
        2014
      ],
      "Van Express 2500": [
        1999,
        2000,
        2001,
        2002,
        2003,
        2004,
        2005,
        2006,
        2007,
        2008,
        2009,
        2010,
        2011,
        2012,
        2013,
        2014,
        2015,
        2016,
        2017,
        2018
      ],
      "Van Express 3500": [
        1999,
        2000,
        2001,
        2002,
        2003,
        2004,
        2005,
        2006,
        2007,
        2008,
        2009,
        2010,
        2011,
        2012,
        2013,
        2014,
        2015,
        2016,
        2017,
        2018
      ]
    },
    "Chrysler": {
      "200": [
        2011,
        2012,
        2013,
        2014,
        2015,
        2016,
        2017
      ],
      "300": [
        2011,
        2012,
        2013,
        2014,
        2015,
        2016,
        2017,
        2018,
        2019,
        2020
      ],
      "Town and Country": [
        2011,
        2012,
        2013,
        2014,
        2015,
        2016
      ]
    },
    "Dodge": {
      "Caravan": [
        2011,
        2012,
        2013,
        2014,
        2015,
        2016,
        2017,
        2018,
        2019
      ],
      "Dodge Truck-1500 (1994 Up)": [
        2013,
        2014,
        2015,
        2016,
        2018,
        2019
      ]
    },
    "Ford": {
      "Crown Vic (1983 Up)": [
        2006,
        2007,
        2008,
        2009,
        2010,
        2011
      ],
      "Escape": [
        2005,
        2006,
        2007,
        2008,
        2009,
        2010,
        2011,
        2012,
        2013,
        2014,
        2015,
        2016,
        2017,
        2018,
        2019,
        2020
      ],
      "Expedition": [
        2003,
        2004,
        2005,
        2006,
        2007,
        2008,
        2009,
        2010,
        2011,
        2012,
        2013,
        2014
      ],
      "Focus": [
        2002,
        2003,
        2004
      ],
      "Fusion": [
        2006,
        2007,
        2008,
        2009,
        2010,
        2011,
        2012,
        2013,
        2014,
        2015,
        2016,
        2017,
        2018,
        2019,
        2020
      ],
      "Mustang": [
        1999,
        2001
      ],
      "Ranger": [
        1999,
        2000,
        2001,
        2002,
        2003
      ],
      "Truck-F150": [
        2001,
        2002,
        2003,
        2004,
        2005,
        2006,
        2007,
        2008,
        2009,
        2010,
        2011,
        2012,
        2013,
        2014,
        2015,
        2016,
        2017,
        2018,
        2019,
        2020
      ],
      "Truck-F150 Raptor": [
        2017,
        2018,
        2019,
        2020
      ],
      "Truck-F250 Super Duty (1999 Up)": [
        2005,
        2006,
        2007,
        2008,
        2009,
        2010
      ],
      "Truck-F350 Super Duty (1999 Up)": [
        2005,
        2006,
        2007,
        2008,
        2009,
        2010
      ],
      "Truck-Ranger": [
        1999,
        2000,
        2001,
        2002,
        2003
      ]
    },
    "GMC": {
      "Suburban-1500 (2001 Down)": [
        2007,
        2008,
        2009,
        2010,
        2011,
        2012,
        2013,
        2014
      ],
      "Truck-Sierra 1500 (1999 Up)": [
        2007,
        2008,
        2009,
        2010,
        2011,
        2012,
        2013
      ],
      "Truck-Yukon (except XL)": [
        2007,
        2008,
        2009,
        2010,
        2011,
        2012,
        2013,
        2014
      ],
      "Truck-Yukon XL1500": [
        2007,
        2008,
        2009,
        2010,
        2011,
        2012,
        2013,
        2014
      ],
      "Van Savana 1500": [
        2008,
        2009,
        2010,
        2011,
        2012,
        2013,
        2014
      ]
    },
    "Honda": {
      "Odyssey": [
        2005,
        2006,
        2007,
        2008,
        2009,
        2010,
        2011,
        2012,
        2013,
        2014,
        2015,
        2016,
        2017,
        2018,
        2019,
        2020
      ],
      "Pilot": [
        2003,
        2004,
        2005,
        2006,
        2007,
        2008,
        2009,
        2010,
        2011,
        2012,
        2013,
        2014,
        2015,
        2016,
        2017,
        2018,
        2019,
        2020
      ]
    },
    "Hyundai": {
      "Santa Fe": [
        2005,
        2006,
        2007,
        2008,
        2009,
        2010,
        2011,
        2012,
        2013,
        2014,
        2015,
        2016,
        2017,
        2018,
        2019
      ],
      "Sonata": [
        2010
      ]
    },
    "Kia": {
      "Optima": [
        2005,
        2006,
        2007,
        2008,
        2009,
        2010,
        2019
      ],
      "Sorento": [
        2005,
        2006,
        2007,
        2008,
        2009,
        2011,
        2012,
        2013,
        2014,
        2015,
        2016,
        2017,
        2018,
        2019,
        2020
      ],
      "Sportage": [
        2005,
        2006,
        2007,
        2008,
        2009,
        2010
      ]
    },
    "Lexus": {
      "ES350": [
        2007,
        2008,
        2009,
        2010,
        2011,
        2012,
        2013,
        2014,
        2015,
        2016,
        2017,
        2018,
        2019
      ],
      "GS350": [
        2007,
        2008,
        2009,
        2010,
        2011,
        2013,
        2014,
        2015,
        2016,
        2017,
        2018,
        2019
      ],
      "RX350": [
        2007,
        2008,
        2009,
        2010,
        2011,
        2012,
        2013,
        2014,
        2015,
        2016,
        2017,
        2018,
        2019
      ],
      "RX350L": [
        2018,
        2019
      ]
    },
    "Lincoln": {
      "MKC": [
        2015,
        2016,
        2017,
        2018,
        2019
      ],
      "MKZ": [
        2007,
        2008,
        2009,
        2010,
        2011,
        2012,
        2013,
        2014,
        2015,
        2016,
        2017,
        2018,
        2019,
        2020
      ]
    },
    "Subaru": {
      "Forester": [
        2005,
        2006,
        2007,
        2008,
        2009,
        2010,
        2011,
        2012,
        2013,
        2014,
        2015,
        2016,
        2017,
        2018,
        2019,
        2020
      ],
      "Impreza": [
        2000,
        2001,
        2002,
        2003,
        2004,
        2005,
        2006,
        2007,
        2008,
        2009,
        2010,
        2011,
        2012,
        2013,
        2014,
        2015,
        2016,
        2017,
        2018,
        2019
      ],
      "Legacy": [
        2005,
        2006,
        2007,
        2008,
        2009,
        2010,
        2011,
        2012,
        2013,
        2014,
        2015,
        2016,
        2017,
        2018,
        2019
      ]
    },
    "Toyota": {
      "Camry": [
        2007,
        2008,
        2009,
        2010,
        2011,
        2012,
        2013,
        2014,
        2015,
        2016,
        2017,
        2018,
        2019,
        2020
      ],
      "Highlander": [
        2008,
        2009,
        2010,
        2011,
        2012,
        2013,
        2014,
        2015,
        2016,
        2017,
        2018,
        2019,
        2020
      ],
      "RAV4": [
        2004,
        2005,
        2006,
        2007,
        2008
      ]
    }
    },
  "Transmission": {
      "Toyota": {
          "Camry": [
              2016,
              2017,
              2018,
              2019,
              2020
          ],
          "Highlander": [
              2016,
              2017,
              2018,
              2019,
              2020
          ]
      },
      "Subaru": {
          "Forester": [
              2017,
              2018,
              2019,
              2020
          ],
          "Legacy": [
              2016,
              2017,
              2018,
              2019
          ],
          "Impreza": [
              2017,
              2018,
              2019
          ]
      },
      "Lincoln": {
          "MKZ": [
              2017,
              2018,
              2019,
              2020
          ],
          "MKC": [
              2017,
              2018,
              2019
          ]
      },
      "Kia": {
          "Sorento": [
              2017,
              2018,
              2019,
              2020
          ],
          "Optima": [
              2019
          ]
      },
      "Honda": {
          "Pilot": [
              2017,
              2018,
              2019,
              2020
          ],
          "Odyssey": [
              2017,
              2018,
              2019,
              2020
          ]
      },
      "Ford": {
          "Truck-F150 Raptor": [
              2017,
              2018,
              2019,
              2020
          ],
          "Truck-F150": [
              2017,
              2018,
              2019,
              2020
          ],
          "Fusion": [
              2017,
              2018,
              2019,
              2020
          ],
          "Escape": [
              2017,
              2018,
              2019,
              2020
          ]
      },
      "Chrysler": {
          "200": [
              2017
          ],
          "300": [
              2017,
              2018,
              2019,
              2020
          ]
      },
      "Chevy": {
          "Truck-Silverado 3500 (2001 Up)": [
              2017,
              2018,
              2019,
              2020
          ],
          "Truck-Silverado 2500 (1999 Up)": [
              2017,
              2018,
              2019,
              2020
          ],
          "Truck-Silverado 1500 (1999 Up)": [
              2017,
              2018,
              2019,
              2020
          ],
          "Truck-Colorado": [
              2017,
              2018,
              2019,
              2020
          ],
          "Tahoe": [
              2017,
              2018,
              2019,
              2020
          ],
          "Suburban-1500": [
              2018,
              2019,
              2020
          ],
          "Malibu": [
              2017,
              2018,
              2019,
              2020
          ],
          "Impala (1980 Up)": [
              2017,
              2018,
              2019,
              2020
          ],
          "Equinox": [
              2017,
              2018,
              2019,
              2020
          ],
          "Camaro": [
              2017,
              2018,
              2019,
              2020
          ],
          "Blazer (2019 Up)": [
              2020
          ],
          "Traverse": [
              2018,
              2019
          ],
          "Cruze": [
              2017,
              2018,
              2019
          ],
          "Corvette": [
              2017,
              2018,
              2019
          ],
          "Blazer ( Up)": [
              2019
          ],
          "Van Express 3500": [
              2017,
              2018
          ],
          "Van Express 2500": [
              2017,
              2018
          ],
          "Suburban-3500": [
              2017,
              2018
          ],
          "Suburban-2500 (1967 Up)": [
              2017
          ]
      },
      "Lexus": {
          "RX350L": [
              2018,
              2019
          ],
          "RX350": [
              2017,
              2018,
              2019
          ],
          "GS350": [
              2017,
              2018,
              2019
          ],
          "ES350": [
              2017,
              2018,
              2019
          ]
      },
      "Hyundai": {
          "Santa Fe": [
              2017,
              2018,
              2019
          ]
      },
      "Dodge": {
          "Truck-1500 (1994 Up)": [
              2018,
              2019
          ],
          "Caravan": [
              2017,
              2018,
              2019
          ]
      }
  }
};

